import React from 'react';
import { I18n } from '@aws-amplify/core';
import { useLocation } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import { Row, Col, Form, Button, Collapse } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import {
	Organization,
	Company,
	Sector,
	Line,
	Workstation,
	EvaluationName,
	NumberOfWorkers,
	WorkersName,
	WrittenWorkProcedure,
	Training,
	EarlyManifestation,
	SymptomLocation
} from './Components/Inputs';
import type { FormFields } from '../types';
import * as S from './styles';

const { useForm } = Form;
const { Panel } = Collapse;

interface FilterProps {
	loading?: boolean;
	onSubmit(values: FormFields): void;
	onCancel(): void;
}

export function Filter({ loading = false, onSubmit, onCancel }: Readonly<FilterProps>): JSX.Element {
	const [form] = useForm<FormFields>();
	const { search } = useLocation();
	const { organization, company } = useApplicationContext();

	const initialValues: FormFields = { organization_id: organization?.id!, company_id: company?.id! };

	return (
		<S.CollapseWrapper defaultActiveKey={search ? '1' : '0'}>
			<Panel key="1" header={I18n.get('Filter')}>
				<Form
					form={form}
					layout="vertical"
					onFinish={onSubmit}
					initialValues={initialValues}
					// onFieldsChange={handleFieldsChange}
				>
					<Row gutter={8}>
						<Col sm={6}>
							<Organization />
						</Col>
						<Col sm={6}>
							<Company />
						</Col>
						<Col sm={6}>
							<Sector />
						</Col>
						<Col sm={6}>
							<Line />
						</Col>
					</Row>
					<Row gutter={8}>
						<Col sm={6}>
							<Workstation />
						</Col>
						<Col sm={6}>
							<EvaluationName />
						</Col>
						<Col sm={6}>
							<NumberOfWorkers />
						</Col>
						<Col sm={6}>
							<WorkersName />
						</Col>
					</Row>
					<Row gutter={8}>
						<Col sm={6}>
							<WrittenWorkProcedure />
						</Col>
						<Col sm={6}>
							<Training />
						</Col>
						<Col sm={6}>
							<EarlyManifestation />
						</Col>
						<Col sm={6}>
							<SymptomLocation />
						</Col>
					</Row>
					<Row gutter={8} style={{ paddingTop: '20px' }}>
						<Col sm={4}>
							<Button
								type="primary"
								loading={loading}
								htmlType="submit"
								icon={<SearchOutlined />}
								style={{ width: '100%' }}
							>
								{I18n.get('Search')}
							</Button>
						</Col>
						<Col sm={4}>
							<Button style={{ width: '100%' }} onClick={onCancel}>
								{I18n.get('Clear')}
							</Button>
						</Col>
					</Row>
				</Form>
			</Panel>
		</S.CollapseWrapper>
	);
}
